import { ReactComponent as CALENDAR } from '../assets/images/projectImage/eccprojectImage/calendar.svg'
import { ReactComponent as CLIENT } from '../assets/images/projectImage/eccprojectImage/client.svg'
import { ReactComponent as DELIVERY } from '../assets/images/projectImage/eccprojectImage/delivery.svg'
import { ReactComponent as INDUSTRY } from '../assets/images/projectImage/eccprojectImage/industry.svg'

// ios
import { ReactComponent as IDEAAVATAR } from '../assets/images/Avatars/ios/IDEAAVATAR.svg'
import { ReactComponent as LAUNCH } from '../assets/images/Avatars/ios/LAUNCH.svg'
import { ReactComponent as OPTIMIZATION } from '../assets/images/Avatars/ios/OPTIMIZATION.svg'
import { ReactComponent as PROTOTYPING } from '../assets/images/Avatars/ios/PROTOTYPING.svg'
import { ReactComponent as DEVELOPMENT } from '../assets/images/Avatars/ios/DEVELOPMENT.svg'
import { ReactComponent as Idea } from "../assets/images/Avatars/ios/Idea.svg";
import { ReactComponent as USER } from "../assets/images/Avatars/ios/USER.svg";
import { ReactComponent as THOROUGH } from "../assets/images/Avatars/ios/THOROUGH.svg";
import { ReactComponent as PROGRAM } from "../assets/images/Avatars/ios/PROGRAM.svg";
import { ReactComponent as PROTOTYPE } from "../assets/images/Avatars/ios/PROTOTYPE.svg";
import { ReactComponent as SWIFT } from "../assets/images/Avatars/ios/SWIFT.svg";
import ROBO from "../assets/images/aboutUsImages/robo.svg";

// Android
import { ReactComponent as ANDROIDSTRATEGY } from '../assets/images/Avatars/Android/ANDROIDSTRATEGY.svg'
import { ReactComponent as EXECUTION } from '../assets/images/Avatars/Android/EXECUTION.svg'
import { ReactComponent as REFINING } from '../assets/images/Avatars/Android/REFINING.svg'
import { ReactComponent as SKILLS } from "../assets/images/Avatars/Android/SKILLS.svg";
import { ReactComponent as DESIGN } from "../assets/images/Avatars/Android/DESIGN.svg";
import { ReactComponent as LOGIN } from "../assets/images/Avatars/Android/LOGIN.svg";
import { ReactComponent as SECURITY } from "../assets/images/Avatars/Android/SECURITY.svg";
import { ReactComponent as PERSONALIZATION } from "../assets/images/Avatars/Android/PERSONALIZATION.svg"

// enterprise
import { ReactComponent as MASKGROUP } from "../assets/images/Avatars/enterprise/MASKGROUP.svg";
import { ReactComponent as INTEGRATION } from "../assets/images/Avatars/enterprise/INTEGRATION.svg";
import { ReactComponent as SECURITYENTER } from "../assets/images/Avatars/enterprise/SECURITYENTER.svg";
import { ReactComponent as SCALABILITY } from "../assets/images/Avatars/enterprise/SCALABILITY.svg";
import { ReactComponent as DESIGNENTER } from "../assets/images/Avatars/enterprise/DESIGNENTER.svg";
import { ReactComponent as SOLIDDEV } from "../assets/images/Avatars/enterprise/SOLIDDEV.svg";
import { ReactComponent as EVALUATION } from "../assets/images/Avatars/enterprise/EVALUATION.svg";
import { ReactComponent as ONGOING } from "../assets/images/Avatars/enterprise/ONGOING.svg";

// appSupport
import { ReactComponent as SKILLS1 } from "../assets/images/Avatars/appSupport/SKILLS.svg";
import { ReactComponent as DESIGN1 } from "../assets/images/Avatars/appSupport/DESIGN.svg";
import { ReactComponent as LOGIN1 } from "../assets/images/Avatars/appSupport/LOGIN.svg";
import { ReactComponent as SECURITY1 } from "../assets/images/Avatars/appSupport/SECURITY.svg";
import { ReactComponent as PERSONALIZATION1 } from "../assets/images/Avatars/appSupport/PERSONALIZATION.svg";

// customService
import { ReactComponent as SERVICEDISCOVERY } from "../assets/images/Avatars/customService/SERVICEDISCOVERY.svg";
import { ReactComponent as SERVICEDESIGN } from "../assets/images/Avatars/customService/SERVICEDESIGN.svg";
import { ReactComponent as SERVICEIMPLEMEN } from "../assets/images/Avatars/customService/SERVICEIMPLEMEN.svg";
import { ReactComponent as SERVICETESTING } from "../assets/images/Avatars/customService/SERVICETESTING.svg";
import { ReactComponent as SERVICESUPPORT } from "../assets/images/Avatars/customService/SERVICESUPPORT.svg";

// healthCare
import { ReactComponent as HEALTHDEV } from "../assets/images/Avatars/healthCare/HEALTHDEV.svg";
import { ReactComponent as HEALTHTESTING } from "../assets/images/Avatars/healthCare/HEALTHTESTING.svg";
import { ReactComponent as HEALTHONGOING } from "../assets/images/Avatars/healthCare/HEALTHONGOING.svg";

// eCommerce
import { ReactComponent as COMPUTER } from "../assets/images/Avatars/eCommerce/COMPUTER.svg";
import { ReactComponent as SALE } from "../assets/images/Avatars/eCommerce/SALE.svg";
import { ReactComponent as TRANSACTION } from "../assets/images/Avatars/eCommerce/TRANSACTION.svg";
import { ReactComponent as INCREASE } from "../assets/images/Avatars/eCommerce/INCREASE.svg";
import { ReactComponent as CONNECTION } from "../assets/images/Avatars/eCommerce/CONNECTION.svg";
import { ReactComponent as ECONLINE } from "../assets/images/Avatars/eCommerce/ECONLINE.svg";
import { ReactComponent as ECTESTING } from "../assets/images/Avatars/eCommerce/ECTESTING.svg";
import { ReactComponent as ECDISCOVERY } from "../assets/images/Avatars/eCommerce/ECDISCOVERY.svg";

// webApp
import { ReactComponent as CUSTOM } from "../assets/images/Avatars/webApp/CUSTOM.svg";
import { ReactComponent as COMPATIBILITY } from "../assets/images/Avatars/webApp/COMPATIBILITY.svg";
import { ReactComponent as STRUCTURE } from "../assets/images/Avatars/webApp/STRUCTURE.svg";
import { ReactComponent as INTEGRATION1 } from "../assets/images/Avatars/webApp/INTEGRATION.svg";
import { ReactComponent as SECURITYWEB } from "../assets/images/Avatars/webApp/SECURITYWEB.svg";
import { ReactComponent as WEBDESIGN } from "../assets/images/Avatars/webApp/WEBDESIGN.svg";
import { ReactComponent as WEBDEV } from "../assets/images/Avatars/webApp/WEBDEV.svg";
import { ReactComponent as WEBTESTING } from "../assets/images/Avatars/webApp/WEBTESTING.svg";
import { ReactComponent as WEBPLANNING } from "../assets/images/Avatars/webApp/WEBPLANNING.svg";

// wordPress
import { ReactComponent as FLEXIBILITY } from "../assets/images/Avatars/wordPress/FLEXIBILITY.svg";
import { ReactComponent as OPTIMIZATIONWORD } from "../assets/images/Avatars/wordPress/OPTIMIZATIONWORD.svg";
import { ReactComponent as SCALE } from "../assets/images/Avatars/wordPress/SCALE.svg";
import { ReactComponent as USERWORD } from "../assets/images/Avatars/wordPress/USERWORD.svg";
import { ReactComponent as WORDSECURITY } from "../assets/images/Avatars/wordPress/WORDSECURITY.svg";
import { ReactComponent as WORDDEV } from "../assets/images/Avatars/wordPress/WORDDEV.svg";
import { ReactComponent as WORDTESTING } from "../assets/images/Avatars/wordPress/WORDTESTING.svg";
import { ReactComponent as WORDLAUNCH } from "../assets/images/Avatars/wordPress/WORDLAUNCH.svg";

// websiteSupport
import { ReactComponent as WEBSECURITY } from "../assets/images/Avatars/websiteSupport/WEBSECURITY.svg";
import { ReactComponent as ENHANCING } from "../assets/images/Avatars/websiteSupport/ENHANCING.svg";
import { ReactComponent as UPDATES } from "../assets/images/Avatars/websiteSupport/UPDATES.svg";
import { ReactComponent as RECOVERY } from "../assets/images/Avatars/websiteSupport/RECOVERY.svg";
import { ReactComponent as SUPPORT } from "../assets/images/Avatars/websiteSupport/SUPPORT.svg";
import { ReactComponent as WSOPTIMIZATION } from "../assets/images/Avatars/websiteSupport/WSOPTIMIZATION.svg";
import { ReactComponent as WSUPDATES } from "../assets/images/Avatars/websiteSupport/WSUPDATES.svg";
import { ReactComponent as WSRECOVERY } from "../assets/images/Avatars/websiteSupport/WSRECOVERY.svg";
import { ReactComponent as WSSUPPORT } from "../assets/images/Avatars/websiteSupport/WSSUPPORT.svg";
import { ReactComponent as WEBPLANS } from "../assets/images/Avatars/websiteSupport/WEBPLANS.svg";
import { ReactComponent as WEBSUPPORT } from "../assets/images/Avatars/websiteSupport/WEBSUPPORT.svg";
import { ReactComponent as WEBPROACTIVE } from "../assets/images/Avatars/websiteSupport/WEBPROACTIVE.svg";
import { ReactComponent as WEBSCHEDULE } from "../assets/images/Avatars/websiteSupport/WEBSCHEDULE.svg";

// hospitalDash
import { ReactComponent as HOSDASHINTEGRATE } from "../assets/images/Avatars/hospitalDash/HOSDASHINTEGRATE.svg";
import { ReactComponent as HOSDASHTESTING } from "../assets/images/Avatars/hospitalDash/HOSDASHTESTING.svg";
import { ReactComponent as HOSDASHSUPPORT } from "../assets/images/Avatars/hospitalDash/HOSDASHSUPPORT.svg";

// hospitalIntranet
import { ReactComponent as HOSDASHINTEGRATE1 } from "../assets/images/Avatars/hospitalIntranet/HOSDASHINTEGRATE.svg";
import { ReactComponent as HOSDASHTESTING1 } from "../assets/images/Avatars/hospitalIntranet/HOSDASHTESTING.svg";
import { ReactComponent as HOSDASHSUPPORT1 } from "../assets/images/Avatars/hospitalIntranet/HOSDASHSUPPORT.svg";

// epdSystem
import { ReactComponent as EPDDATASHARING } from "../assets/images/Avatars/epdSystem/EPDDATASHARING.svg";
import { ReactComponent as EPDPATIENT } from "../assets/images/Avatars/epdSystem/EPDPATIENT.svg";
import { ReactComponent as EPDREGULATIONS } from "../assets/images/Avatars/epdSystem/EPDREGULATIONS.svg";
import { ReactComponent as EPDINTEGRATION } from "../assets/images/Avatars/epdSystem/EPDINTEGRATION.svg";
import { ReactComponent as EPDCAPACITY } from "../assets/images/Avatars/epdSystem/EPDCAPACITY.svg";
import { ReactComponent as HEALTHDEV1 } from "../assets/images/Avatars/epdSystem/HEALTHDEV.svg";
import { ReactComponent as HEALTHTESTING1 } from "../assets/images/Avatars/epdSystem/HEALTHTESTING.svg";
import { ReactComponent as HEALTHONGOING1 } from "../assets/images/Avatars/epdSystem/HEALTHONGOING.svg";

// erpSoftware
import { ReactComponent as ERPBUSINESS } from "../assets/images/Avatars/erpSoftware/ERPBUSINESS.svg";
import { ReactComponent as ERPDECISION } from "../assets/images/Avatars/erpSoftware/ERPDECISION.svg";
import { ReactComponent as ERPINTEGRATION } from "../assets/images/Avatars/erpSoftware/ERPINTEGRATION.svg";
import { ReactComponent as ERPPRODUCTIVITY } from "../assets/images/Avatars/erpSoftware/ERPPRODUCTIVITY.svg";
import { ReactComponent as HEALTHDEV2 } from "../assets/images/Avatars/erpSoftware/HEALTHDEV.svg";
import { ReactComponent as HEALTHTESTING2 } from "../assets/images/Avatars/erpSoftware/HEALTHTESTING.svg";
import { ReactComponent as HEALTHONGOING2 } from "../assets/images/Avatars/erpSoftware/HEALTHONGOING.svg";

// saasSoftware
import { ReactComponent as SAASDEV1 } from "../assets/images/Avatars/saasSoftware/SAASDEV1.svg";
import { ReactComponent as SAASDEV2 } from "../assets/images/Avatars/saasSoftware/SAASDEV2.svg";
import { ReactComponent as HEALTHDEV3 } from "../assets/images/Avatars/saasSoftware/HEALTHDEV.svg";
import { ReactComponent as HEALTHTESTING3 } from "../assets/images/Avatars/saasSoftware/HEALTHTESTING.svg";
import { ReactComponent as HEALTHONGOING3 } from "../assets/images/Avatars/saasSoftware/HEALTHONGOING.svg";

import STORYMAGIC from "../assets/images/storyMagic/heroBg.png";
import QUIVVER from '../assets/images/projectImage/quivverImages/banner.webp'
import AIDOCTOR from '../assets/images/projectImage/aiDoctorImage/app1Screen.webp'
import CRYONE from '../assets/images/projectImage/cryoneimage/cryone_banner.webp'
import AICHAT from '../assets/images/projectImage/aichatImage/aichat_banner.webp'

import { uploadImageToCloudinary } from '../helper/functions'

export const finalImages = [
    {
        "key": "BULB",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079774/sattva-images/bulb.d524ae86d759550cebe4854b5e28cd6d_cvcseh_nnylxa.svg"
    },
    {
        "key": "STRATEGY",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079773/sattva-images/startegy.97c23a81ab31e8030a6de0c6f8262060_gxnto3_rtajno.svg"
    },
    {
        "key": "LEAD",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079771/sattva-images/lead.84dc7439a3ed346bccef7338b136d2a4_vqji3u_vjzmrd.svg"
    },
    {
        "key": "SALES",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079772/sattva-images/sales.58b4e009d3c087c5b680d3769b30756b_jhvnez_ryxpwu.svg"
    },
    {
        "key": "TESTING",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079773/sattva-images/testing.1220fecf425f25f9454cb21b55e29339_c4tlmk_uha2b8.svg"
    },
    {
        "key": "TRAINING",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079773/sattva-images/training.b7d72ff199f2eb1c169b307240f205a8_lghoor_pokaic.svg"
    },
    {
        "key": "REVIEW",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079773/sattva-images/review.e03643682e0d8628685af08d552b2ccd_j8ysrn_uiwz0m.svg"
    },
    {
        "key": "IMG",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079792/sattva-images/testimonial-image.f8fba2b66df51bde286c_ouux0u_p8doml.png"
    },
    {
        "key": "ProjectImage",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079789/sattva-images/projectImage.bcfada04842901a6542c_phpbyt_zgp5zb.png"
    },
    {
        "key": "REACT",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079772/sattva-images/react.22066ba64005c680e03463a67f82e8c9_mhrshf_tapfa7.svg"
    },
    {
        "key": "NODE",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079779/sattva-images/node.1707c7cc09139b7e065ed9236ae791a0_yqllsv_gcovtl.svg"
    },
    {
        "key": "MYSQL",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079775/sattva-images/mysql.9368efe2c8354d4a4808466ead30d8d1_ffuqn5_qkifgc.svg"
    },
    {
        "key": "GOGGLE",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079775/sattva-images/Google.9aefd664a7f66f6ccec05e42cbf6c6a1_frzf0v_z6vc97.svg"
    },
    {
        "key": "VUE",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079775/sattva-images/vue.8b79168facc5bf240443b25ef1285564_pampl3_b2meyt.svg"
    },
    {
        "key": "Idea",
        "url": <Idea />
    },
    {
        "key": "PROGRAM",
        "url": <PROGRAM />
    },
    {
        "key": "USER",
        "url": <USER />
    },
    {
        "key": "PROTOTYPE",
        "url": <PROTOTYPE />
    },
    {
        "key": "THOROUGH",
        "url": <THOROUGH />
    },
    {
        "key": "SWIFT",
        "url": <SWIFT />
    },
    {
        "key": "SKILLS",
        "url": <SKILLS />
    },
    {
        "key": "DESIGN",
        "url": <DESIGN />
    },
    {
        "key": "LOGIN",
        "url": <LOGIN />
    },
    {
        "key": "PERSONALIZATION",
        "url": <PERSONALIZATION />
    },
    {
        "key": "SECURITY",
        "url": <SECURITY />
    },
    {
        "key": "MASKGROUP",
        "url": <MASKGROUP />
    },
    {
        "key": "INTEGRATION",
        "url": <INTEGRATION />
    },
    {
        "key": "SECURITYENTER",
        "url": <SECURITYENTER />
    },
    {
        "key": "SCALABILITY",
        "url": <SCALABILITY />
    },
    {
        "key": "DESIGNENTER",
        "url": <DESIGNENTER />
    },
    {
        "key": "COMPUTER",
        "url": <COMPUTER />
    },
    {
        "key": "SALE",
        "url": <SALE />
    },
    {
        "key": "TRANSACTION",
        "url": <TRANSACTION />
    },
    {
        "key": "CONNECTION",
        "url": <CONNECTION />
    },
    {
        "key": "INCREASE",
        "url": <INCREASE />
    },
    {
        "key": "CUSTOM",
        "url": <CUSTOM />
    },
    {
        "key": "COMPATIBILITY",
        "url": <COMPATIBILITY />
    },
    {
        "key": "STRUCTURE",
        "url": <STRUCTURE />
    },
    {
        "key": "SECURITYWEB",
        "url": <SECURITYWEB />
    },
    {
        "key": "FLEXIBILITY",
        "url": <FLEXIBILITY />
    },
    {
        "key": "OPTIMIZATIONWORD",
        "url": <OPTIMIZATIONWORD />
    },
    {
        "key": "USERWORD",
        "url": <USERWORD />
    },
    {
        "key": "SCALE",
        "url": <SCALE />
    },
    {
        "key": "RECOVERY",
        "url": <RECOVERY />
    },
    {
        "key": "ENHANCING",
        "url": <ENHANCING />
    },
    {
        "key": "SUPPORT",
        "url": <SUPPORT />
    },
    {
        "key": "UPDATES",
        "url": <UPDATES />
    },
    {
        "key": "WEBPLANS",
        "url": <WEBPLANS />
    },
    {
        "key": "WEBSUPPORT",
        "url": <WEBSUPPORT />
    },
    {
        "key": "WEBPROACTIVE",
        "url": <WEBPROACTIVE />
    },
    {
        "key": "WEBSCHEDULE",
        "url": <WEBSCHEDULE />
    },
    {
        "key": "IDEAAVATAR",
        "url": <IDEAAVATAR />
    },
    {
        "key": "PROTOTYPING",
        "url": <PROTOTYPING />
    },
    {
        "key": "DEVELOPMENT",
        "url": <DEVELOPMENT />
    },
    {
        "key": "OPTIMIZATION",
        "url": <OPTIMIZATION />
    },
    {
        "key": "LAUNCH",
        "url": <LAUNCH />
    },
    {
        "key": "REFINING",
        "url": <REFINING />
    },
    {
        "key": "ANDROIDSTRATEGY",
        "url": <ANDROIDSTRATEGY />
    },
    {
        "key": "EXECUTION",
        "url": <EXECUTION />
    },
    {
        "key": "SOLIDDEV",
        "url": <SOLIDDEV />
    },
    {
        "key": "EVALUATION",
        "url": <EVALUATION />
    },
    {
        "key": "ONGOING",
        "url": <ONGOING />
    },
    {
        "key": "SERVICEDESIGN",
        "url": <SERVICEDESIGN />
    },
    {
        "key": "SERVICEDISCOVERY",
        "url": <SERVICEDISCOVERY />
    },
    {
        "key": "SERVICEIMPLEMEN",
        "url": <SERVICEIMPLEMEN />
    },
    {
        "key": "SERVICESUPPORT",
        "url": <SERVICESUPPORT />
    },
    {
        "key": "SERVICETESTING",
        "url": <SERVICETESTING />
    },
    {
        "key": "ECDISCOVERY",
        "url": <ECDISCOVERY />
    },
    {
        "key": "ECONLINE",
        "url": <ECONLINE />
    },
    {
        "key": "ECTESTING",
        "url": <ECTESTING />
    },
    {
        "key": "HEALTHDEV",
        "url": <HEALTHDEV />
    },
    {
        "key": "HEALTHONGOING",
        "url": <HEALTHONGOING />
    },
    {
        "key": "HEALTHTESTING",
        "url": <HEALTHTESTING />
    },
    {
        "key": "WEBDESIGN",
        "url": <WEBDESIGN />
    },
    {
        "key": "WEBDEV",
        "url": <WEBDEV />
    },
    {
        "key": "WEBPLANNING",
        "url": <WEBPLANNING />
    },
    {
        "key": "WEBTESTING",
        "url": <WEBTESTING />
    },
    {
        "key": "WORDDEV",
        "url": <WORDDEV />
    },
    {
        "key": "WORDLAUNCH",
        "url": <WORDLAUNCH />
    },
    {
        "key": "WORDTESTING",
        "url": <WORDTESTING />
    },
    {
        "key": "WSOPTIMIZATION",
        "url": <WSOPTIMIZATION />
    },
    {
        "key": "WSRECOVERY",
        "url": <WSRECOVERY />
    },
    {
        "key": "WSSUPPORT",
        "url": <WSSUPPORT />
    },
    {
        "key": "WSUPDATES",
        "url": <WSUPDATES />
    },
    {
        "key": "HOSDASHINTEGRATE",
        "url": <HOSDASHINTEGRATE />
    },
    {
        "key": "HOSDASHSUPPORT",
        "url": <HOSDASHSUPPORT />
    },
    {
        "key": "HOSDASHTESTING",
        "url": <HOSDASHTESTING />
    },
    {
        "key": "CRMCENTRALIZED",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079784/sattva-images/wFGL8EngEfNmwAAAABJRU5ErkJggg_r7fg11_lyxbdd.png"
    },
    {
        "key": "CRMCUSTOMER",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079783/sattva-images/eJ2ehl_KILd6RV1bsqaWUE1diNuYu7kQP4ZibCjKB6jeBHSfawG5C8hkAxPperF7t9F1ANl8qP9w84FRHz_RsvtZe9O14iVYPs7SR7E9MGv8pl5PtDtLF_iCTFxQgAAAAASUVORK5CYII_myhwjp_tyrnzs.png"
    },
    {
        "key": "CRMINTEGRATION",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079786/sattva-images/BEQRKU8Un2ObvMQL4O7xdmC8aZgS9AAAAAElFTkSuQmCC_qrxlgc_pkynfw.png"
    },
    {
        "key": "CRMSCALABLE",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079785/sattva-images/CQj_HftxpFzkz4AAAAAElFTkSuQmCC_ropjhe_tyaoq1.png"
    },
    {
        "key": "CRMSUSTAINABLE",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079785/sattva-images/wFGL8EngEfNmwAAAABJRU5ErkJggg_n0csmk_lxgt3i.png"
    },
    {
        "key": "ERPBUSINESS",
        "url": <ERPBUSINESS />
    },
    {
        "key": "ERPDECISION",
        "url": <ERPDECISION />
    },
    {
        "key": "ERPINTEGRATION",
        "url": <ERPINTEGRATION />
    },
    {
        "key": "ERPPRODUCTIVITY",
        "url": <ERPPRODUCTIVITY />
    },
    {
        "key": "ABOUTCHAT",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079788/sattva-images/BcFuShYiMF74BMf_wKfN9JUgAAAAASUVORK5CYII_l1juri_yr7167.png"
    },
    {
        "key": "ABOUTGOODLUCK",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079788/sattva-images/xBaQpMMuRyJfTp1ngjzdneh4xDbxD96qfNrPW0Tv1Q3jRZt7WMvpfdTvhjF2gAAAABJRU5ErkJggg_zja0b1_joypim.png"
    },
    {
        "key": "ABOUTHANDSHAKE",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079784/sattva-images/fzrzstqanDKgTfT3cR_RpitRPMIaKQ2EFUpMRu_y_lv8DjaoQKA6alesAAAAASUVORK5CYII_ttogym_hukgog.png"
    },
    {
        "key": "ABOUTMOTIVATION",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079786/sattva-images/hQsXklmcbKo6_EA8iCoh1p5PTU3dP2HChO1s5dQJKwH7ozKmfwGJdaSXmt8NrAAAAABJRU5ErkJggg_xallgm_bqvbvs.png"
    },
    {
        "key": "ABOUTPEOPLE",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079786/sattva-images/DNh7KuAAAAABJRU5ErkJggg_licjnm_ywey4o.png"
    },
    {
        "key": "ABOUTRESPECT",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079786/sattva-images/wNkKt7xSCymJgAAAABJRU5ErkJggg_qysh0w_o7fjv8.png"
    },
    {
        "key": "EPDCAPACITY",
        "url": <EPDCAPACITY />
    },
    {
        "key": "EPDDATASHARING",
        "url": <EPDDATASHARING />
    },
    {
        "key": "EPDINTEGRATION",
        "url": <EPDINTEGRATION />
    },
    {
        "key": "EPDPATIENT",
        "url": <EPDPATIENT />
    },
    {
        "key": "EPDREGULATIONS",
        "url": <EPDREGULATIONS />
    },
    {
        "key": "CAREERCHARGE",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079787/sattva-images/CzjL2SqwjLqzBMi429QE26fd0DvmdKoN4z_6rMfERERERERERERERERERGRxvwDcSWaZsGz7lsAAAAASUVORK5CYII_srexkw_vpbmif.png"
    },
    {
        "key": "CAREERCOLLEAGUE",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079787/sattva-images/aPz3DR_eGtWfxAAAAAElFTkSuQmCC_wvbeou_ckreuh.png"
    },
    {
        "key": "CAREERCOMPANY",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079787/sattva-images/vO6nvTsRDiCdN4euUQE4C7S6F0AAAAASUVORK5CYII_hu14hp_xk9n6o.png"
    },
    {
        "key": "CAREERDOMAIN",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079787/sattva-images/zOCbPxKDevFKr8VwYzON5G_stsTDHJJJ_0I2m79f18b7LVlvzQpAAAAAElFTkSuQmCC_cnhzgg_jorvfx.png"
    },
    {
        "key": "CAREERSKULL",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079787/sattva-images/AS2NJkGGS31SAAAAAElFTkSuQmCC_tobp1w_dgib3h.png"
    },
    {
        "key": "CAREERTECH",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079787/sattva-images/qMgY_QHa4YRvoYuCs3D9uzqdBZQy8Qs2z3eE7EEOpxNik7Y8AAAAASUVORK5CYII_gpudkg_fuddes.png"
    },
    {
        "key": "AIBANNERIMAGE",
        "url": AICHAT
    },
    {
        "key": "ECCBANNERIMAGE",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079788/sattva-images/ecc-banner-image.513437fd36bc412c0789_xrdo3b_deiamq.webp"
    },
    {
        "key": "BITEUBANNERIMAGE",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079788/sattva-images/bitEu-banner-image.6214885bef038348fd35_p9iqs1_psvnta.webp"
    },
    {
        "key": "MOODYBANNERIMAGE",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079788/sattva-images/moody-banner-image.0cad92150036644247cd_fmi4rv_xvgp8s.webp"
    },
    {
        "key": "NODEJS",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079787/sattva-images/node.0a8d7d51cb2b6d940b6f_y99fys_qevpn3.png"
    },
    {
        "key": "WEB3",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743079787/sattva-images/Ml7YBtzR44Wrmxp_Mw5CNuLGG8D1ZS1udEHcyIzFjVVPZAgGmT22J3X_A9k7HltSH01MAAAAAElFTkSuQmCC_u4hrrb_p4xxcc.png"
    },

    {
        "key": "MOODYAPPBANNERIMAGE",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743143455/sattva-images/moodyAppBanner.f9dabad576e5789110c3_fopucn.webp"
    },
    {
        "key": "BITEUWEBBANNER",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743143455/sattva-images/banner-app.bbaee19f82312be2b5b6_brsnno.webp"
    },
    {
        "key": "ECCAPPBANNER",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1743143455/sattva-images/ecc-app-image.78c98385965d069905d3_sgvvjx.webp"
    },
    {
        "key": "WORDSECURITY",
        "url": <WORDSECURITY />
    },
    {
        "key": "WEBSECURITY",
        "url": <WEBSECURITY />
    },
    {
        "key": "APP1",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1744958991/sattva-images/app1.0855f09f257997e80604_lk5uzq.png"
    },
    {
        "key": "APP2",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1744958988/sattva-images/app2.5c0138d3e71730f63078_ks4wck.png"
    },
    {
        "key": "APP3",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1744958988/sattva-images/app3.65240794d6909a931171_cym0ew.png"
    },
    {
        "key": "CLIENT",
        "url": <CLIENT />
    },
    {
        "key": "CALENDAR",
        "url": <CALENDAR />
    },
    {
        "key": "INDUSTRY",
        "url": <INDUSTRY />
    },
    {
        "key": "DELIVERY",
        "url": <DELIVERY />
    },
    {
        "key": "SKILLS1",
        "url": <SKILLS1 />
    },
    {
        "key": "DESIGN1",
        "url": <DESIGN1 />
    },
    {
        "key": "LOGIN1",
        "url": <LOGIN1 />
    },
    {
        "key": "SECURITY1",
        "url": <SECURITY1 />
    },
    {
        "key": "PERSONALIZATION1",
        "url": <PERSONALIZATION1 />
    },
    {
        "key": "INTEGRATION1",
        "url": <INTEGRATION1 />
    },
    {
        "key": "HOSDASHINTEGRATE1",
        "url": <HOSDASHINTEGRATE1 />
    },
    {
        "key": "HOSDASHTESTING1",
        "url": <HOSDASHTESTING1 />
    },
    {
        "key": "HOSDASHSUPPORT1",
        "url": <HOSDASHSUPPORT1 />
    },
    {
        "key": "HEALTHDEV1",
        "url": <HEALTHDEV1 />
    },
    {
        "key": "HEALTHTESTING1",
        "url": <HEALTHTESTING1 />
    },
    {
        "key": "HEALTHONGOING1",
        "url": <HEALTHONGOING1 />
    },
    {
        "key": "HEALTHDEV2",
        "url": <HEALTHDEV2 />
    },
    {
        "key": "HEALTHTESTING2",
        "url": <HEALTHTESTING2 />
    },
    {
        "key": "HEALTHONGOING2",
        "url": <HEALTHONGOING2 />
    },
    {
        "key": "SAASDEV1",
        "url": <SAASDEV1 />
    },
    {
        "key": "SAASDEV2",
        "url": <SAASDEV2 />
    },
    {
        "key": "HEALTHDEV3",
        "url": <HEALTHDEV3 />
    },
    {
        "key": "HEALTHTESTING3",
        "url": <HEALTHTESTING3 />
    },
    {
        "key": "HEALTHONGOING3",
        "url": <HEALTHONGOING3 />
    },
    {
        "key": "STORYMAGIC",
        "url": STORYMAGIC
    },
    {
        "key": "QUIVVER",
        "url": QUIVVER
    },
    {
        "key": "AIDOCTOR",
        "url": AIDOCTOR
    },
    {
        "key": "CRYONE",
        "url": CRYONE
    },
    {
        "key": "ABOUTUSSVG",
        "url": "https://res.cloudinary.com/dwsfpccgt/image/upload/v1767874258/sattva-images/vjh9lsuglsrzyufrsyvu.svg"

    },
    {
        "key": "ABOUTUSROBO",
        "url": ROBO
    },
    
]

export const migrateImages = async () => {
    const promises = finalImages.map(async (image: any) => {
        const res = await uploadImageToCloudinary(image.url);
        const url = res
            ? (typeof res === 'string' ? res : res.url)
            : image.url;
        return {
            "key": image.key,
            "url": url
        };
    });

    // Wait for all promises to resolve
    const final = await Promise.all(promises);
    console.log('final :>> ', final);
    return final;
}

export const getImage = (key: string) => {
    let imgArr = finalImages.filter(imgKey => {
        return imgKey.key === key
    })
    if (imgArr.length > 0) return imgArr[0].url
    else return ""
}
